import { unlockTherapistConstant } from 'src/redux/actions/constant';

const {
  GET_UNLOCK_THERAPIST_REQUEST,
  GET_UNLOCK_THERAPIST_SUCCESS,
  GET_UNLOCK_THERAPIST_FAILURE,
  GET_UNLOCK_THERAPIST_RESET,
  GET_UNLOCK_THERAPIST_LOADING,
} = unlockTherapistConstant;

const intialState: object = {
  response: null,
  isGetUnlock: false,
  loading: false,
};

export const getUnlockTherapistReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_UNLOCK_THERAPIST_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isGetUnlock: true,
        loading: false,
      };
    }
    case GET_UNLOCK_THERAPIST_FAILURE: {
      return {
        ...state,
        response: action.payload,
        isGetUnlock: false,
        loading: false,
      };
    }

    case GET_UNLOCK_THERAPIST_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_UNLOCK_THERAPIST_RESET:
      return intialState;

    default:
      return state;
  }
};
